module.exports = __webpack_public_path__ + "img/building_pingtai.771d3814.png";